export const TIPTAP_PDF_STYLE_ADJUSTMENTS = {
  underline: {
    textDecorationThickness: '1px',
  },
  highlight: {
    translateY: '11px',
  },
  blockquote: {
    borderLeft: '2px solid #000000',
    margin: '15px 0 0 0',
    paddingLeft: '15px',
    childrenTop: '-10px',
    childrenLeft: '-7px',
  },
};
